module.exports = __webpack_public_path__ + "img/50.3eb153f9.svg";